import { render } from "./UserProfileImage.vue?vue&type=template&id=8a8e62c4&scoped=true"
import script from "./UserProfileImage.vue?vue&type=script&lang=js"
export * from "./UserProfileImage.vue?vue&type=script&lang=js"

import "./UserProfileImage.vue?vue&type=style&index=0&id=8a8e62c4&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8e62c4"]])

export default __exports__